module.exports = __webpack_public_path__ + "static/media/Balance.463b34b4.svg";